import { HttpClient } from '@angular/common/http';
import { Injectable, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import normalizeUrl from 'normalize-url';
import { MessageService } from 'primeng/api';
import { throwError as observableThrowError, Subject } from 'rxjs';
import { environment } from '../../environments/environment';
import { StaticConfig } from './static_config';

@Injectable()
export class ConfigService implements OnInit {
	public maxpageelement = 20;
	public mailmaxpageelement = 20;
	public id_categoria_contratto = 1;
	public fg_id_contratto_appalto = 0;
	public base_url_browser: string;
	public base_url: string;
	public portalUrl: string;
	public serviceUrl_Documentale: string;
	public companiesUrl: string;
	public wfUrl: string;
	public drUrl: string;
	public serviceUrl_Login: string;
	public urlbaseLogin: string;
	public imageBaseURL: string;
	public onlineshopImageUrl: string = '';
	public bakekaImageUrl: string = '';
	public placesImageUrl: string = '';
	public alertEvent = false;
	public urlRDBService: string;
	public urlRFIService: string;
	public urlRDBSqlServer: string;
	public urlStrike: string;
	public cnaUrl: string;
	public hrurl: string;
	public bakekaUrl: string;
	public onlineshopurl: string;
	public automezziUrl: string;
	public bookingUrl: string;
	public paymentUrl: string = '';
	public paypal_clientId: string = '';
	public nexi_script: string = '';
	public bizAppointmentsUrl: string;
	public mailServiceUrl: string = '';
	public fattureConfigUrl: string = '';
	language = 'it';
	private numOfNotSource = new Subject<any>();
	numOfNot$ = this.numOfNotSource.asObservable();
	// Notifica il cambio dell'immagine profilo (setUserAvatar) ai componenti che la cacheano (es. header)
	private avatarChangedSource = new Subject<string>();
	avatarChanged$ = this.avatarChangedSource.asObservable();
	private config: any;
	Object = null;
	public cestino: string;
	public inarrivo: string;
	public inviate: string;
	public bozze: string;
	public spam: string;
	public db_prefix: string;
	public dimensioneseparatoredefault = 0;
	public apiGoogleMapsKey = '';
	public min_psw_length = 12;
	public static resetStorage() {}

	public folderTrovata = false;

	get mailUrl(): string {
		return this.mailServiceUrl;
	}

	public homeFolder = 0;

	private cachedRoles: string[] | null = null;
	private cachedAdminRoles: string[] | null = null;

	private wait_until_refreshtoken_done = false;
	private _lastErrorToastTime = 0;

	constructor(
		private translate: TranslateService,
		private messageService: MessageService,
		private spinnerService: NgxSpinnerService,
	) {
		this.mailmaxpageelement = StaticConfig.mailmaxpageelement;
		this.maxpageelement = StaticConfig.maxpageelement;
		this.id_categoria_contratto = StaticConfig.id_categoria_contratto;
		this.fg_id_contratto_appalto = StaticConfig.fg_id_contratto_appalto;
		this.mailServiceUrl = StaticConfig.mailServiceUrl;
		this.fattureConfigUrl = StaticConfig.fattureConfigUrl;
		this.base_url_browser = StaticConfig.base_url_browser;
		this.base_url = StaticConfig.base_url;
		this.portalUrl = StaticConfig.portalUrl;
		this.serviceUrl_Documentale = StaticConfig.serviceUrl_Documentale;
		this.companiesUrl = StaticConfig.companiesUrl;
		this.drUrl = StaticConfig.drUrl;
		this.wfUrl = StaticConfig.wfUrl;
		this.hrurl = StaticConfig.hrurl;
		this.automezziUrl = StaticConfig.automezziUrl;
		this.bookingUrl = StaticConfig.bookingUrl;
		this.paymentUrl = StaticConfig.paymentUrl;
		this.bakekaUrl = StaticConfig.bakekaUrl;
		this.onlineshopurl = StaticConfig.onlineshopurl;
		this.paypal_clientId = StaticConfig.paypal_clientId;
		this.nexi_script = StaticConfig.nexi_script;
		this.bizAppointmentsUrl = StaticConfig.bizAppointmentsUrl;
		this.automezziUrl = StaticConfig.automezziUrl;

		this.serviceUrl_Login = StaticConfig.serviceUrl_Login;
		this.urlRDBService = StaticConfig.urlRDBService;
		this.urlRFIService = StaticConfig.urlRFIService;
		this.urlRDBSqlServer = StaticConfig.urlRDBSqlServer;
		this.urlStrike = StaticConfig.urlStrike;
		this.cnaUrl = StaticConfig.cnaUrl;
		this.urlbaseLogin = StaticConfig.urlbaseLogin;
		this.imageBaseURL = StaticConfig.imageBaseURL;
		this.onlineshopImageUrl = StaticConfig.onlineshopImageUrl;
		this.bakekaImageUrl = StaticConfig.bakekaImageUrl;
		this.placesImageUrl = StaticConfig.placesImageUrl;
		this.cestino = StaticConfig.cestino;
		this.inarrivo = StaticConfig.inarrivo;
		this.inviate = StaticConfig.inviate;
		this.bozze = StaticConfig.bozze;
		this.spam = StaticConfig.spam;
		this.db_prefix = StaticConfig.db_prefix;
		this.apiGoogleMapsKey = StaticConfig.apiGoogleMapsKey;
	}
	ngOnInit(): void {
		this.load();
	}

	isUserSuperAdmin(): boolean {
		let usr = this.getAdminUser();
		let userRoles: string[] | null = null;
		if (!usr) {
			usr = this.getUser();
			userRoles = this.getUserRoles();
		} else {
			userRoles = this.getAdminUserRoles();
		}
		if (!usr || !usr.token) return false;
		const requireAll = false;
		const rolesToCheck = 'ADMIN';

		if (!userRoles?.length) return false;

		try {
			const token = usr.token;
			const decryptedToken = atob(token.substring(token.indexOf('.') + 1, token.lastIndexOf('.')));
			const payload = JSON.parse(decryptedToken);

			// Check if user has ADMIN role
			if (!userRoles?.length) return false;

			return userRoles.includes('ADMIN');
		} catch (e) {
			console.error('[isUserSuperAdmin] Errore decodifica token:', e);
			return false;
		}
	}

	/**
	 * ADMIN dell'utente CORRENTE (currentUser), ignorando l'impersonificazione.
	 * Da usare per il gating dei CONTENUTI (es. azioni in lista) che devono
	 * riflettere l'utente impersonato, non l'admin che sta impersonando.
	 * NB: isUserSuperAdmin() invece dà priorità all'admin (per i controlli admin
	 * dell'header, es. selettore utente, che restano attivi in impersonificazione).
	 */
	isCurrentUserAdmin(): boolean {
		const usr = this.getUser();
		if (!usr || !usr.token) return false;
		const userRoles = this.getUserRoles();
		return !!userRoles?.includes('ADMIN');
	}

	/**
	 * Le authorities sono UNA stringa separata da virgole che contiene sia i ruoli di
	 * portale (ADMIN, GUEST, ...) sia quelli aziendali (TICKETS_MANAGER_RFI,
	 * AZIENDA_MANAGER_ADMIN, ...). Vanno sempre confrontate per elemento intero:
	 * `authorities.includes('ADMIN')` sulla stringa è vero anche per TICKET_MANAGER_ADMIN.
	 */
	static hasAuthority(authorities: string | null | undefined, role: string): boolean {
		if (!authorities) return false;
		return authorities
			.split(',')
			.map((r) => r.trim())
			.includes(role);
	}

	/** Come sopra, sull'utente corrente (ruoli letti dal token). */
	hasRole(role: string): boolean {
		return !!this.getUserRoles()?.includes(role);
	}

	isAuthenticated(): boolean {
		let usr = this.getUser();
		if (usr && usr.token) {
			try {
				let payload = JSON.parse(atob(usr.token.split('.')[1]));
				let currentTime = Math.floor(Date.now() / 1000);
				return payload.exp > currentTime;
			} catch (e) {
				return false;
			}
		}
		return false;
	}

	setCompany_id(select_company: number) {
		localStorage.setItem('def_company_id', select_company.toString());
	}

	getCompany_id(): number {
		const id = localStorage.getItem('def_company_id');
		return id !== null ? parseInt(id, 10) : -1;
	}

	// L'ultima azienda selezionata e il suo tema vanno ricordati attraverso logout /
	// sessione scaduta: si salvano prima del localStorage.clear() e si ripristinano
	// subito dopo, così la pagina di login resta con i colori dell'azienda e al
	// prossimo login si rientra nell'ultima azienda. L'AuthGuard valida poi l'accesso
	// e applica il fallback se l'azienda non e' piu' disponibile.
	getCompanyMemento(): { id: string | null; name: string | null; theme: string | null } {
		return {
			id: localStorage.getItem('def_company_id'),
			name: localStorage.getItem('def_company_name'),
			theme: localStorage.getItem('theme'),
		};
	}

	restoreCompanyMemento(memento: { id: string | null; name: string | null; theme: string | null }): void {
		if (memento.id) localStorage.setItem('def_company_id', memento.id);
		if (memento.name) localStorage.setItem('def_company_name', memento.name);
		if (memento.theme) localStorage.setItem('theme', memento.theme);
	}

	// localStorage.clear() che conserva ultima azienda e tema (logout, token scaduto)
	clearStorageKeepingCompany(): void {
		const memento = this.getCompanyMemento();
		localStorage.clear();
		this.restoreCompanyMemento(memento);
	}

	// Riapplica il tema ricordato: all'avvio dell'app (anche sulla pagina di login,
	// prima che l'AuthGuard risolva l'azienda) e dopo un F5
	applyStoredTheme(): void {
		document.documentElement.setAttribute('kcs-theme', localStorage.getItem('theme') || 'default');
	}

	// Gruppo funzionale dell'azienda corrente (standard | condominio): pilota campi extra, label e sezioni dedicate
	setCompanyGroup(group: string) {
		localStorage.setItem('def_company_group', group || 'standard');
	}

	getCompanyGroup(): string {
		return localStorage.getItem('def_company_group') || 'standard';
	}

	setCompanyLogo(logo: string): void {
		localStorage.setItem('def_company_logo', logo);
	}

	getCompanyLogo(): string {
		const logo = localStorage.getItem('def_company_logo');
		return logo !== null ? logo : 'Multiportale';
	}

	totNot(not: any) {
		this.numOfNotSource.next(not);
	}

	getConfig(key: any) {
		return this.config[key];
	}

	async load() {
		await this.loadProduzione();
	}

	loadProduzione(): Promise<boolean> {
		// Configurazione caricata a compile-time da src/environments/environment.ts
		// (sostituito da Angular fileReplacements in angular.json per i profili
		// test, prod, local, local-prod, ecc.). Niente piu' fetch runtime su config.json.
		const env = environment;

		const prefix = (path: string | undefined): string => {
			if (!path) return '';
			return path.includes('http') ? path : env.base_url_browser + path;
		};

		this.base_url_browser = env.base_url_browser;
		StaticConfig.base_url_browser = this.base_url_browser;
		this.base_url = env.base_url;
		StaticConfig.base_url = this.base_url;
		this.portalUrl = prefix(env.portalUrl);
		StaticConfig.portalUrl = this.portalUrl;
		this.serviceUrl_Documentale = prefix(env.serviceUrl_Documentale);
		StaticConfig.serviceUrl_Documentale = this.serviceUrl_Documentale;
		this.companiesUrl = prefix(env.companiesUrl);
		StaticConfig.companiesUrl = this.companiesUrl;
		this.drUrl = prefix(env.drUrl);
		StaticConfig.drUrl = this.drUrl;
		this.wfUrl = prefix(env.wfUrl);
		StaticConfig.wfUrl = this.wfUrl;
		this.hrurl = prefix(env.hrurl);
		StaticConfig.hrurl = this.hrurl;
		this.automezziUrl = prefix(env.automezziUrl);
		StaticConfig.automezziUrl = this.automezziUrl;
		this.bookingUrl = prefix(env.bookingUrl);
		StaticConfig.bookingUrl = this.bookingUrl;
		this.paymentUrl = prefix(env.paymentUrl);
		StaticConfig.paymentUrl = this.paymentUrl;
		this.paypal_clientId = env.paypal_clientId || '';
		StaticConfig.paypal_clientId = this.paypal_clientId;
		this.nexi_script = env.nexi_script || '';
		StaticConfig.nexi_script = this.nexi_script;
		this.bizAppointmentsUrl = prefix(env.bizAppointmentsUrl);
		StaticConfig.bizAppointmentsUrl = this.bizAppointmentsUrl;
		this.serviceUrl_Login = prefix(env.serviceUrl_Login);
		StaticConfig.serviceUrl_Login = this.serviceUrl_Login;
		this.urlRDBService = prefix(env.urlRDBService);
		StaticConfig.urlRDBService = this.urlRDBService;
		this.urlRFIService = prefix(env.urlRFIService);
		StaticConfig.urlRFIService = this.urlRFIService;
		this.urlRDBSqlServer = prefix(env.urlRDBSqlServer);
		StaticConfig.urlRDBSqlServer = this.urlRDBSqlServer;
		this.urlStrike = prefix(env.urlStrike);
		StaticConfig.urlStrike = this.urlStrike;
		this.cnaUrl = prefix(env.cnaUrl);
		StaticConfig.cnaUrl = this.cnaUrl;
		this.mailServiceUrl = prefix(env.mailUrl);
		StaticConfig.mailServiceUrl = this.mailServiceUrl;
		this.fattureConfigUrl = prefix(env.fattureConfigUrl);
		StaticConfig.fattureConfigUrl = this.fattureConfigUrl;
		this.spam = env.spam;
		StaticConfig.spam = this.spam;
		this.db_prefix = env.db_prefix;
		StaticConfig.db_prefix = this.db_prefix;
		this.apiGoogleMapsKey = env.apiGoogleMapsKey;
		StaticConfig.apiGoogleMapsKey = this.apiGoogleMapsKey;
		this.imageBaseURL = env.imageBaseURL;
		StaticConfig.imageBaseURL = this.imageBaseURL;
		// Se non esplicitato nell'env, deriva da imageBaseURL (cartella temp/onlineshop)
		this.onlineshopImageUrl = env.onlineshopImageUrl || this.imageBaseURL + '/temp/onlineshop';
		StaticConfig.onlineshopImageUrl = this.onlineshopImageUrl;
		// Foto/audio turismo (bacheca + luoghi): servite staticamente da LSWS dalla
		// cartella PERSISTENTE /var/www/bacheca/turismo (NON /temp, ripulita ogni 20 min),
		// mappata sul dominio come /bacheca/turismo. Base derivata dall'host di imageBaseURL
		// (che termina con /assets) salvo override esplicito:
		//  - env.turismoMediaUrl  -> base completa (es. https://host/bacheca/turismo)
		//  - env.bakekaImageUrl / env.placesImageUrl -> override puntuali (usati in DEV via junction)
		const turismoBase = env.turismoMediaUrl || this.imageBaseURL.replace(/\/assets\/?$/, '') + '/bacheca/turismo';
		this.bakekaImageUrl = env.bakekaImageUrl || turismoBase + '/bakeka';
		StaticConfig.bakekaImageUrl = this.bakekaImageUrl;
		this.placesImageUrl = env.placesImageUrl || turismoBase + '/places';
		StaticConfig.placesImageUrl = this.placesImageUrl;
		this.fg_id_contratto_appalto = +(env.fg_id_contratto_appalto || 0);
		StaticConfig.fg_id_contratto_appalto = this.fg_id_contratto_appalto;
		this.bakekaUrl = prefix(env.bakekaUrl);
		StaticConfig.bakekaUrl = this.bakekaUrl;
		this.onlineshopurl = prefix(env.onlineshopurl);
		StaticConfig.onlineshopurl = this.onlineshopurl;
		return Promise.resolve(true);
	}

	public extractData(res: Response) {
		return res.json();
	}

	public handleErrorObservable(error: Response | any) {
		return observableThrowError(error);
	}

	public handleErrorPromise(error: Response | any) {
		return Promise.reject(error.message || error);
	}

	openErrorNotify(message: string = '') {
		const now = Date.now();
		if (now - this._lastErrorToastTime < 1000) {
			return;
		}
		this._lastErrorToastTime = now;
		this.messageService.add({
			severity: 'error',
			summary: 'Errore',
			detail: message,
			life: 6000,
		});
	}

	openErrorEnchantedNotify(errorResponse: any) {
		this._lastErrorToastTime = Date.now();
		this.messageService.add({
			severity: 'error',
			summary: 'Errore servizio interno',
			data: errorResponse,
			key: 'error-toast',
			life: 6000,
		});
	}

	openSuccessNotify(message: string = '') {
		this.messageService.add({
			severity: 'success',
			summary: 'Successo',
			detail: message,
			life: 4000,
		});
	}

	openInfoNotify(summary: string, message: string = '') {
		this.messageService.add({
			severity: 'info',
			summary: summary,
			detail: message,
			life: 5000,
		});
	}

	openWarnNotify(message: string = '') {
		this.messageService.add({
			severity: 'warn',
			summary: 'Attenzione',
			detail: message,
			life: 6000,
		});
	}

	getLocalStorageObjectJson(key: string) {
		let _val = JSON.parse(localStorage.getItem(key) || '{}');
		if (Object.keys(_val).length === 0) {
			return null;
		}
		return _val;
	}

	getUser(): any {
		let currentUser: any;
		let currentUserString = localStorage.getItem('currentUser');
		if (currentUserString) {
			currentUser = JSON.parse(currentUserString);
		}
		return currentUser;
	}

	getAdminUser(): any {
		let currentUser: any;
		let currentUserString = localStorage.getItem('currentUserAdmin');
		if (currentUserString) {
			currentUser = JSON.parse(currentUserString);
		}
		return currentUser;
	}

	private getUserRoles(): string[] | null {
		if (this.cachedRoles) return this.cachedRoles;

		const usr = this.getUser();
		if (!usr) return [];

		const token = usr.token;
		const decryptedToken = atob(token.substring(token.indexOf('.') + 1, token.lastIndexOf('.')));
		this.cachedRoles = JSON.parse(decryptedToken).role.split(',');
		return this.cachedRoles;
	}

	private getAdminUserRoles(): string[] | null {
		// Cache separata da cachedRoles: durante l'impersonificazione i ruoli
		// dell'utente corrente non sono quelli dell'admin e non vanno mischiati
		if (this.cachedAdminRoles) return this.cachedAdminRoles;

		const usr = this.getAdminUser();
		if (!usr) return [];

		const token = usr.token;
		const decryptedToken = atob(token.substring(token.indexOf('.') + 1, token.lastIndexOf('.')));
		this.cachedAdminRoles = JSON.parse(decryptedToken).role.split(',');
		return this.cachedAdminRoles;
	}

	public getLanguage() {
		if (this.getUser() && this.getUser().lang) {
			return this.getUser().lang;
		}
		return this.language;
	}

	public getLocalStorageLanguage() {
		let locallang = localStorage.getItem('language');
		if (locallang) {
			return locallang;
		}
		return 'KO';
	}

	public getTranslate(word: string) {
		let translate = word;
		this.translate.get(word).subscribe((r: any) => {
			translate = r;
		});
		return translate;
	}

	public prepareMediaLink(str: string) {
		let url = this.serviceUrl_Documentale + 'media/stream/' + btoa(str);
		return normalizeUrl(url);
	}

	getUserID(): number {
		let res = 0;
		let localData = localStorage.getItem('currentUser');
		if (localData) {
			let currentUser = JSON.parse(localData);
			res = currentUser.usr_id;
		}
		return res;
	}

	getUserName(): string {
		let res = '';
		let localData = localStorage.getItem('currentUser');
		if (localData) {
			let currentUser = JSON.parse(localData);
			res = currentUser.usr_username;
		}
		return res;
	}

	getPortalID(): number {
		let res = 0;
		let localData = localStorage.getItem('portale');
		if (localData) {
			let portale = JSON.parse(localData);
			res = portale.pt_id;
		}
		return res;
	}

	/**
	 * Format the date to "YYYY-MM-DD"
	 */
	formatDateToString(event: Date) {
		if (event) {
			const year = event.getFullYear();
			const month = ('0' + (event.getMonth() + 1)).slice(-2); // Add leading zero
			const day = ('0' + event.getDate()).slice(-2); // Add leading zero
			return `${year}-${month}-${day}`;
		}
		return '';
	}

	// format time to string 00:00
	formatTimeToString(event: any) {
		const arr = event;
		if (arr && arr.length >= 2) {
			const hours = ('0' + event[0]).slice(-2);
			const minutes = ('0' + event[1]).slice(-2);
			return `${hours}:${minutes}`;
		}
		return '';
	}

	// format obj to date
	formatDate(event: any) {
		const arr = event;
		if (arr && arr.length >= 3) {
			event = new Date(arr[0], arr[1] - 1, arr[2], arr[3] || 0, arr[4] || 0, arr[5] || 0);
		} else {
			event = null;
		}
		return event;
	}

	private colors = [
		'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
		'linear-gradient(135deg, #ff6b6b 0%, #ff8e53 100%)',
		'linear-gradient(135deg, #4ecdc4 0%, #45b7d1 100%)',
		'linear-gradient(135deg, #3498db 0%, #2ecc71 100%)',
		'linear-gradient(135deg, #e74c3c 0%, #f1c40f 100%)',
		'linear-gradient(135deg, #1abc9c 0%, #e67e22 100%)',
		'linear-gradient(135deg, #c0392b 0%, #2980b9 100%)',
		'linear-gradient(135deg, #27ae60 0%, #f39c12 100%)',
		'linear-gradient(135deg, #16a085 0%, #d35400 100%)',
		'linear-gradient(135deg, #cc2b5e 0%, #753a88 100%)',
		'linear-gradient(135deg, #42275a 0%, #734b6d 100%)',
		'linear-gradient(135deg, #de6262 0%, #ffb88c 100%)',
		'linear-gradient(135deg, #06beb6 0%, #48b1bf 100%)',
		'linear-gradient(135deg, #eb3349 0%, #f45c43 100%)',
		'linear-gradient(135deg, #dd5e89 0%, #f7bb97 100%)',
		'linear-gradient(135deg, #56ab2f 0%, #a8e063 100%)',
		'linear-gradient(135deg, #614385 0%, #516395 100%)',
		'linear-gradient(135deg, #02aab0 0%, #00cdac 100%)',
		'linear-gradient(135deg, #d66d75 0%, #e29587 100%)',
		'linear-gradient(135deg, #000428 0%, #004e92 100%)',
		'linear-gradient(135deg, #7b4397 0%, #dc2430 100%)',
		'linear-gradient(135deg, #43cea2 0%, #185a9d 100%)',
		'linear-gradient(135deg, #ba5370 0%, #f4e2d8 100%)',
		'linear-gradient(135deg, #ff512f 0%, #dd2476 100%)',
		'linear-gradient(135deg, #4568dc 0%, #b06ab3 100%)',
		'linear-gradient(135deg, #ec6f66 0%, #f3a183 100%)',
		'linear-gradient(135deg, #3a1c71 0%, #ffaf7b 100%)',
		'linear-gradient(135deg, #4ca1af 0%, #c4e0e5 100%)',
		'linear-gradient(135deg, #ff5f6d 0%, #ffc371 100%)',
		'linear-gradient(135deg, #36d1dc 0%, #5b86e5 100%)',
		'linear-gradient(135deg, #c33764 0%, #1d2671 100%)',
		'linear-gradient(135deg, #141e30 0%, #243b55 100%)',
		'linear-gradient(135deg, #ff7e5f 0%, #feb47b 100%)',
		'linear-gradient(135deg, #a18cd1 0%, #fbc2eb 100%)',
		'linear-gradient(135deg, #ff8177 0%, #b12a5b 100%)',
		'linear-gradient(135deg, #f6d365 0%, #fda085 100%)',
		'linear-gradient(135deg, #a6c0fe 0%, #f68084 100%)',
		'linear-gradient(135deg, #fccb90 0%, #d57eeb 100%)',
		'linear-gradient(135deg, #e0c3fc 0%, #8ec5fc 100%)',
	];

	getColorFromEmail(email: string): string {
		let hash = 0;
		for (let i = 0; i < email.length; i++) {
			hash = email.charCodeAt(i) + ((hash << 5) - hash);
		}
		return this.colors[Math.abs(hash) % this.colors.length];
	}

	getColorFromDisplayName(_displayname: string = ''): string {
		let displayname = _displayname ? _displayname : this.getUser().usr_displayname;
		let hash = 0;
		for (let i = 0; i < displayname.length; i++) {
			hash = displayname.charCodeAt(i) + ((hash << 5) - hash);
		}
		return this.colors[Math.abs(hash) % this.colors.length];
	}

	setLanguage(language: string) {
		localStorage.setItem('language', language.toLocaleLowerCase());
	}

	getUsernameInitials(_name: string = '', _surname: string = ''): string {
		let name = _name ? _name : this.getUser().usr_firstname;
		let surname = _surname ? _surname : this.getUser().usr_lastname;
		return `${name.charAt(0)}${surname.charAt(0)}`.toUpperCase();
	}

	// Immagine profilo dell'utente corrente (data-URL base64), '' se non impostata.
	getUserAvatar(): string {
		// Solo i data-URL sono avatar validi: il DB legacy conteneva path tipo
		// '/avatar/default.svg' (file inesistente) che darebbero un'immagine rotta.
		const avatar = this.getUser()?.avatar || '';
		return avatar.startsWith('data:image') ? avatar : '';
	}

	// Aggiorna l'avatar nel currentUser in localStorage così header e pagine lo mostrano subito.
	setUserAvatar(avatar: string): void {
		const currentUser = this.getUser();
		if (!currentUser) return;
		currentUser.avatar = avatar || '';
		localStorage.setItem('currentUser', JSON.stringify(currentUser));
		this.avatarChangedSource.next(currentUser.avatar);
	}
}
